/** Motif d'une ligne d'acquisition de solde. */
export enum LeaveAccrualReason {
  Presence = 0,
  Entry = 1,
  Exit = 2,
  SickLeave = 3,
  WorkAccident = 4,
  Unpaid = 5,
  Seniority = 6,
  Splitting = 7,
  Rounding = 8,
  Ceiling = 9
}
